export default "__VITE_ASSET__hWDCvHx1__"